import '../modal.css';
import {ModalProps} from "../ModalProps";

export const ModelRules = (props: ModalProps) => {

    if (!props.isOpen) return null;

    return (
        <div className={'modal-overlay'}>
            <div className={'modal-order'}>
                <button className="modal-close-button"
                        onClick={props.onClose}
                        aria-label="Закрыть окно"></button>
                <h2 className={'modal-policy-title'}>
                    Наши правила
                </h2>
                <div className="modal-policy-body">
                    <p>1. Приходить не раньше, чем за 15 минут до начала мероприятия.</p>
                    <p>2. Освободить помещение не позднее 10 минут после окончания мероприятия,
                        иначе далее оплачивается как стоимость часа аренды зала.</p>
                    <p>3. Распитие спиртных напитков запрещается.</p>
                    <p>4. Употреблять пищу/напитки строго в отведенном месте.</p>
                    <p>5. Мы поможем в сервировке вашего стола, но нужно принести\заказать
                        подготовленные продукты для выкладки на праздничный стол\кенди-бар.</p>
                    <p>6. На территории находиться только в носочках или сменной обуви.</p>
                    <p>7. Нахождение в песочнице только в носочках.</p>
                    <p>8. Не выносить песок и игрушки, находящиеся в песочницы, за ее пределы.</p>
                    <p>9. Не есть и не пить в песочнице.</p>
                    <p>10. Порча имущества возмещается в полном размере ее стоимости.</p>
                    <p>11. На каждые пять детей должно быть по одному сопровождающему, но не более 6 взрослых.</p>
                    <p>12. Строго запрещается заходить в «СЛУЖЕБНОЕ ПОМЕЩЕНИЕ» и «АДМИНИСТРАЦИЯ».</p>
                    <p>13. Забронированной датой и временем считается момент заключения договора и внесения аванса.
                        Предварительная бронь (по телефону, через заявки в соц. сетях и мессенджерах) действительна в
                        течении 3 дней, если вы не подошли для заключения договора запись мы аннулируем.</p>
                    <p>Мы осознаем, что эти требования могут показаться излишне требовательными, но это направлено на
                        то, чтобы Ваши дети оставались здоровыми и чувствовали себя комфортно.
                        Надеемся на ваше понимание! С уважением команда "Вау... Празжник!!!"</p>
                </div>
            </div>

        </div>
    )
}